import { render, staticRenderFns } from "./question-detail.vue?vue&type=template&id=bf875566&scoped=true&"
import script from "./question-detail.vue?vue&type=script&lang=ts&"
export * from "./question-detail.vue?vue&type=script&lang=ts&"
import style0 from "./question-detail.vue?vue&type=style&index=0&id=bf875566&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf875566",
  null
  
)

export default component.exports